/** 
  * Class to store the tabs names
 */
export class Tabs {
  static CURRENT = 'current';
  static PHOTOS = 'photos';
  static SCENARIO = 'scenario';
  static FORECAST = 'forecast';
  static HISTORY = 'history';
}